import { Currency } from "./currency.type";

export enum ClientType {
  SALE = "Продажа",
  PURCHASE = "Покупка",
  LOM = "Лом",
}

export interface Client {
  _id: string;
  name: string;
  phone: string;
  totalSoldAmount: number;
  totalPurchasedAmount: number;
  totalPaidAmount: number;
  totalReceivedAmount: number;
  ownerId: string;
  ownerName: string;
  clientType: ClientType;
  debtCurrency: Currency;
  totalClientDebt: number;
  totalCompanyDebt: number;
  maxDiscount?: number;
  createdAt: string;
  updatedAt: string;
}
